// Externally hosted legal policies (Termly). Linked out from the site so the
// policies stay centrally managed and maintained in Termly.
export const LEGAL_LINKS = {
  privacy:
    "https://app.termly.io/policy-viewer/policy.html?policyUUID=112ab8c2-c0cd-4fa9-a73d-8d9a30f9d189",
  terms:
    "https://app.termly.io/policy-viewer/policy.html?policyUUID=1efe1805-c552-4837-900e-155b8c64ff37",
  cookies:
    "https://app.termly.io/policy-viewer/policy.html?policyUUID=99be8d6f-f677-420d-aac1-1fcfcf11a6ff",
};
